const mapStanceToServerInput = (stance) => {
  // Remove all fields that the user is not allowed to edit directly.
  const {
    directQuote,
    copiedStance,
    autoSummary,
    editsMade,
    updatedAt,
    createdAt,
    _id,
    hasError,
    ...stanceRest
  } = stance;
  const isAutoSummary = autoSummary?.isAutoSummary || Boolean(autoSummary?.issue);
  let fieldsToUpdate;

  if(isAutoSummary && copiedStance) {
    fieldsToUpdate = {
      directQuote,
      autoSummary
    };
  } else if(isAutoSummary) {
    fieldsToUpdate = {};
  } else {
    fieldsToUpdate = {
      directQuote,
      ...(autoSummary?.text ? {
        autoSummary: {
          text: autoSummary.text,
          isAutoSummary: false
        }
      } : {})
    };
  }

  return {
    ...stanceRest,
    _id: _id.startsWith('NEW-') ? 'NEW' : _id,
    ...fieldsToUpdate
  };
};

export { mapStanceToServerInput };
